<template>
    <div>
        <o-field label="Application Number *" :type="fieldType('application_number')" :message="getError('application_number')">
            <o-input placeholder="Application Number" v-model="form.application_number"/>
        </o-field>

        <o-field label="Type *" :type="fieldType('type')" :message="getError('type')">
            <o-select placeholder="Select a Type" v-model="form.type" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="type in occupancyCertificateTypes"
                    :value="type.id"
                    :key="type.id">
                    {{ type.name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Applicant *" :type="fieldType('applicant_id')" :message="getError('applicant_id')">
            <o-select placeholder="Select an Applicant" v-model="form.applicant_id" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="applicant in applicants"
                    :value="applicant.id"
                    :key="applicant.id">
                    {{ applicant.full_name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Floor(s) # *" :type="fieldType('floors')" :message="getError('floors')">
            <o-input placeholder="Floor(s)" v-model="form.floors"/>
        </o-field>

        <o-field label="Status *" :type="fieldType('status')" :message="getError('status')">
            <o-select placeholder="Select a Status" v-model="form.status" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="status in occupancyCertificateStatuses"
                    :value="status.id"
                    :key="status.id">
                    {{ status.name }}
                </option>
            </o-select>
        </o-field>
    </div>
</template>

<script>
    import Application from '../../../mixins/Application'
    import HandlesForm from '../../../mixins/HandlesForm'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [Application, HandlesForm],

        data () {
            return {
                form: {
                    application_number: null,
                    applicant_id: null,
                    floors: null,
                    status: null,
                    type: null
                }
            }
        },

        computed: {
            ...mapGetters({
                occupancyCertificateStatuses: 'occupancyCertificateStatuses',
                occupancyCertificateTypes: 'occupancyCertificateTypes',
                applicants: 'contacts'
            })
        }
    }
</script>
